import { Button, Col, Form, Row } from 'antd';
import { AssessmentAPIUseCaseInterface } from 'application/usecases/AssessmentUseCase';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import ChevronDown from 'assets/icons/chevron-down.svg';
import ChevonUp from 'assets/icons/chevron-up-2.svg';
import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { MasterStationsWithSearchKeys } from 'domain/entities/MasterEntity';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormInputAutoComplete } from 'presentation/components/form/FormInputAutoComplete.component';
import {
    completeFetching,
    showConfirm,
    startFetching,
} from 'presentation/redux/features/app/appSlice';
import { useAppSelector } from 'presentation/redux/hooks';
import { AUTH_ROUTES, PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect, useState } from 'react';
import { useCollapse } from 'react-collapsed';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { InputNumberWithFraction } from '../../CU-031-01/components/Input';
import { RangeData } from '../../CU-056-02/Models/Range';

interface data {
    assessmentSimple: AssessmentSimple;
    masterUseCase: MasterUseCaseInterface;
    assessmentUseCase: AssessmentAPIUseCaseInterface;
    stationSelect: any;
    setRange: (range: RangeData) => void;
}
export const FormCostAccounting = ({
    assessmentSimple,
    masterUseCase,
    assessmentUseCase,
    stationSelect,
    setRange,
}: data) => {
    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [isDiasbleRepairFund, setIsDiasbleRepairFund] = useState<boolean>(
        assessmentSimple.rent_price ? false : true,
    );
    const [allStation, setAllStation] = React.useState<OptionEntity[]>([]);
    const [stationCDSelect, setStationSelect] = React.useState<any>();
    const navigate = useNavigate();
    const userSlice = useAppSelector((state) => state.user);

    React.useEffect(() => {
        if (isDiasbleRepairFund) {
            form.setFieldsValue({
                repair_fund: undefined,
            });
        }
    }, [isDiasbleRepairFund]);

    useEffect(() => {
        getStationByKeys('');
        stationSelect && setStationSelect(stationSelect);
        form.setFieldsValue({
            age_building: assessmentSimple.age_building,
            area: assessmentSimple.area,
            station_cd: stationSelect?.label,
            on_foot_time: assessmentSimple.on_foot_time,
            rent_price: assessmentSimple.rent_price ? assessmentSimple.rent_price : '',
            repair_fund: assessmentSimple.repair_fund ? assessmentSimple.repair_fund : '',
        });
        onChangeForm();
    }, []);

    const getStationByKeys = async (key: string) => {
        try {
            dispatch(startFetching());
            const response = await masterUseCase.getMasterStationByKeys(key);
            const stationOption = response.result?.map((item: MasterStationsWithSearchKeys) => {
                return {
                    value: item.stationCd,
                    label: item.stationName,
                    code: item.stationCd,
                };
            });
            const stationList = stationOption.filter(function (item, pos, self) {
                return self.indexOf(item) == pos;
            });
            setAllStation(stationList);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then((values) => {
                if (values.age_building || values.rent_price) {
                    setBtnDisable(false);
                } else {
                    setBtnDisable(true);
                }
            })
            .catch((err) => {
                const isValid = err.errorFields.length == 0;
                if (isValid) {
                    const values = err.values;
                    if (values.age_building || values.rent_price) {
                        setBtnDisable(false);
                    } else {
                        setBtnDisable(true);
                    }
                } else {
                    setBtnDisable(true);
                }
            });
    };

    const onSubmitForm = async (values: any) => {
        try {
            dispatch(startFetching());
            const assessmentSimple: AssessmentSimple = {
                ...values,
                area: commonHelpers.toNumberOnly(values.area),
                rent_price: commonHelpers.toNumberOnly(values.rent_price),
                repair_fund: commonHelpers.toNumberOnly(values.repair_fund),
                station_cd: stationCDSelect?.code,
                stationName: stationCDSelect?.value,
            };
            const response = await assessmentUseCase.putAssessmentSimpleData(assessmentSimple);
            const data = response.result;
            setRange(data);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const checkLogin = async () => {
        if (userSlice?.isSignedIn) {
            navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_028_01);
        } else {
            const confirmProps = {
                message: '以降のステップには\nログインが必要です。',
                okText: 'ログイン・アカウント作成へ',
                cancelText: 'いいえ',
                type: 'info',
                onOk: goToLoginPage,
            };
            dispatch(showConfirm(confirmProps));
        }
    };

    const goToLoginPage = () => {
        navigate(`${AUTH_ROUTES.PATH}/${AUTH_ROUTES.SUB.CU_001_00}`);
    };

    return (
        <div
            className="form-element w-full w-full md:w-2/3 2xl:w-1/2"
            style={{ display: 'flex', justifyContent: 'space-between',  height: 'auto', marginBottom: '5%', overflow: 'auto' }}
        >
            <div
                className="content1 glowd-on-hover"
                style={{ padding: '0px 8px' }}
            >
                <div className="form-title">入力条件</div>
            </div>
            <Form
                form={form}
                onChange={onChangeForm}
                onFinish={onSubmitForm}
                style={{ width: '100%' }}
            >
                <Row className="min-w-min">
                    <div className="w-full mb-[48px]">
                        <Row gutter={[0, 12]} className="md-6">
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="築年数"
                                    required
                                    name="age_building"
                                    type="number"
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="年"
                                    placeholder={PLACEHOLDER.BUILDING_AGE}
                                    maxLength={2}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <InputNumberWithFraction
                                    label="専有面積"
                                    name="area"
                                    isRequired
                                    addonAfter="m²"
                                    labelClassName="content-form label-form"
                                    requiredMessage={getMessage('In_Required', '専有面積')}
                                    placeholder={PLACEHOLDER.OCCUPIED_AREA}
                                    max={999.99}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]} className="md-6">
                            <Col span={12} className="pr-[12px]">
                                <FormInputAutoComplete
                                    name="station_cd"
                                    label="最寄駅"
                                    allowClear={false}
                                    required
                                    size={'large'}
                                    onSelect={(option) => {
                                        setStationSelect(option);
                                        form.setFieldValue('station_cd', option?.label);
                                    }}
                                    options={allStation ?? []}
                                    notFoundContent={'該当するデータはありません。'}
                                    onBlurEvent={(option) => {
                                        if (option) {
                                            setStationSelect(option);
                                            form.setFieldsValue({ station_cd: option.label });
                                        } else {
                                            setStationSelect(undefined);
                                            form.setFieldsValue({ station_cd: null });
                                            form.validateFields(['station_cd'], { validateOnly: false })
                                                .then(() => {
                                                    onChangeForm()
                                                }).catch((err) => {
                                                    if (err.errorFields.length > 0) {
                                                        setBtnDisable(true);
                                                    } else {
                                                        onChangeForm();
                                                    }
                                                });
                                        }
                                    }}
                                    placeholder={PLACEHOLDER.SELECT}
                                    maxLength={20}
                                    labelClassName="content-form label-form"
                                    currentForm={form}
                                    onValidateError={(isError) => {
                                        if (isError) {
                                            setBtnDisable(true);
                                        } else {
                                            onChangeForm();
                                        }
                                    }}
                                />
                            </Col>

                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="徒歩"
                                    name="on_foot_time"
                                    required
                                    placeholder={PLACEHOLDER.ON_FOOT_TIME}
                                    min={1}
                                    max={255}
                                    type="number"
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="分"
                                    maxLength={3}
                                    currentForm={form}
                                    onValidateError={(isError) => {
                                        if (isError) {
                                            setBtnDisable(true);
                                        } else {
                                            onChangeForm();
                                        }
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]} className="md-6">
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="家賃・共益費・管理費など（収入）"
                                    name="rent_price"
                                    placeholder={PLACEHOLDER.RENT}
                                    maxLength={6}
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="円"
                                    type="number"
                                    onChange={(value) => {
                                        setIsDiasbleRepairFund(!value);
                                    }}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="管理費・修繕積立金・その他費用など（支出）"
                                    name="repair_fund"
                                    required={!isDiasbleRepairFund}
                                    disabled={isDiasbleRepairFund}
                                    size={'large'}
                                    labelClassName="content-form label-form"
                                    suffix="円"
                                    placeholder={PLACEHOLDER.MANAGEMENT_FEE_AND_OTHER_EXPENSES}
                                    maxLength={7}
                                    type="number"
                                    currentForm={form}
                                    onValidateError={(isError) => {
                                        if (isError) {
                                            setBtnDisable(true);
                                        } else {
                                            onChangeForm();
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                    </div>
                </Row>

                <div
                    className="content"
                    style={{
                        margin: '5% 0% 0% 0%',
                    }}
                >
                    <Row gutter={[0, 12]} className="mb-6 w-full h-full">
                        <Col span={12} className="pr-[12px]">
                            <Button
                                size="large"
                                className="button-container"
                                style={{
                                    backgroundColor: 'rgba(75, 202, 229, 1)',
                                    border: 'none',
                                }}
                                htmlType="submit"
                                disabled={btnDisable}
                            >
                                再計算
                            </Button>
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <Button
                                type="primary"
                                size="large"
                                className="button-container"
                                onClick={() => checkLogin()}
                            >
                                くわしく査定
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Form>
        </div>
    );
};
